var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.33 4.391h-4.912v-1.786c0-0.447-0.298-0.744-0.744-0.744s-0.744 0.298-0.744 0.744v1.786h-17.563v-1.786c0-0.447-0.298-0.744-0.744-0.744s-0.744 0.298-0.744 0.744v1.786h-5.060c-0.447 0-0.744 0.298-0.744 0.744v24.26c0 0.447 0.298 0.744 0.744 0.744h30.512c0.447 0 0.744-0.298 0.744-0.744v-24.26c0-0.447-0.447-0.744-0.744-0.744zM5.879 5.879v1.786c0 0.447 0.298 0.744 0.744 0.744s0.744-0.298 0.744-0.744v-1.786h17.563v1.786c0 0.447 0.298 0.744 0.744 0.744s0.744-0.298 0.744-0.744v-1.786h4.167v6.549h-29.172v-6.549h4.465zM1.414 28.651v-14.735h29.023v14.735h-29.023z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.837 16.893h2.828v2.828h-2.828v-2.828z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.749 16.893h2.828v2.828h-2.828v-2.828z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.809 16.893h2.828v2.828h-2.828v-2.828z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.721 16.893h2.828v2.828h-2.828v-2.828z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.781 16.893h2.828v2.828h-2.828v-2.828z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.837 21.507h2.828v2.828h-2.828v-2.828z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.749 21.507h2.828v2.828h-2.828v-2.828z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.809 21.507h2.828v2.828h-2.828v-2.828z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.721 21.507h2.828v2.828h-2.828v-2.828z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.781 21.507h2.828v2.828h-2.828v-2.828z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b73d32bd29be8478c572c94ed66b2c62.svg";
export { ForwardRef as ReactComponent };